import React from 'react';

export default class Notes extends React.Component {
    update = (e) => {
        this.props.actions.saveNote(e.target.value);
    }

    render() {
        return (
            <div id="actionRow">
                <table width="100%" cellPadding="6">
                    <tbody>
                        <tr>
                            <td style={ { width: '50%' } }>
                                <strong>Notes For The Coach:</strong><br />
                                <textarea
                                    className="giveBorder"
                                    id="coachNotes"
                                    value={ this.props.note }
                                    onChange={ this.update } />
                            </td>
                        </tr>
                    </tbody>
               </table>
            </div>
        );
    }
}
